var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-md-4" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "Tipo documento *" } },
          [
            _c(
              "v-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                class: {
                  "v-select-danger": _vm.errors.has(
                    "custom-document-part-2.documentType"
                  )
                },
                attrs: {
                  "data-cy": "document-type",
                  "data-vv-as": "tipo documento",
                  name: "documentType",
                  options: _vm.optionDocumentType
                },
                model: {
                  value: _vm.documentForm.documentType,
                  callback: function($$v) {
                    _vm.$set(_vm.documentForm, "documentType", $$v)
                  },
                  expression: "documentForm.documentType"
                }
              },
              [
                _c("template", { slot: "no-options" }, [
                  _vm._v(" no hay tipo documento para el criterio de búsqueda ")
                ])
              ],
              2
            ),
            _vm.errors.has("custom-document-part-2.documentType")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger v-enter-to"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first(
                              "custom-document-part-2.documentType"
                            )
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-4" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "Nº documento *" } },
          [
            _c("b-form-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                "data-cy": "document-number",
                "data-vv-as": "nº documento",
                name: "documentNumber",
                type: "number",
                state: _vm.errors.has("custom-document-part-2.documentNumber")
                  ? false
                  : null,
                formatter: _vm.maxLength
              },
              model: {
                value: _vm.documentForm.documentNumber,
                callback: function($$v) {
                  _vm.$set(_vm.documentForm, "documentNumber", $$v)
                },
                expression: "documentForm.documentNumber"
              }
            }),
            _vm.errors.has("custom-document-part-2.documentNumber")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger v-enter-to"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first(
                              "custom-document-part-2.documentNumber"
                            )
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-4" },
      [
        _c("InputCurrency", {
          directives: [
            {
              name: "validate",
              rawName: "v-validate",
              value: "required|min:1",
              expression: "'required|min:1'"
            }
          ],
          attrs: {
            id: "amount",
            name: "amount",
            "data-cy": "amount",
            label: "Monto *",
            state: _vm.errors.has("custom-document-part-2.amount")
              ? false
              : null,
            danger: _vm.errors.has("custom-document-part-2.amount"),
            "danger-text": _vm.errors.first("custom-document-part-2.amount"),
            "data-vv-as": "monto"
          },
          model: {
            value: _vm.documentForm.amount,
            callback: function($$v) {
              _vm.$set(_vm.documentForm, "amount", $$v)
            },
            expression: "documentForm.amount"
          }
        })
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-6" },
      [
        _c(
          "b-form-group",
          { attrs: { label: "Emitida por *" } },
          [
            _c("b-form-input", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: "required",
                  expression: "'required'"
                }
              ],
              attrs: {
                "data-cy": "emited-by",
                "data-vv-as": "emitida por",
                name: "emitedBy",
                state: _vm.errors.has("custom-document-part-2.emitedBy")
                  ? false
                  : null,
                maxLength: "150"
              },
              model: {
                value: _vm.documentForm.emitedBy,
                callback: function($$v) {
                  _vm.$set(_vm.documentForm, "emitedBy", $$v)
                },
                expression: "documentForm.emitedBy"
              }
            }),
            _vm.errors.has("custom-document-part-2.emitedBy")
              ? _c(
                  "div",
                  {
                    staticClass:
                      "con-text-validation span-text-validation-danger v-enter-to"
                  },
                  [
                    _c("span", { staticClass: "span-text-validation" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.errors.first("custom-document-part-2.emitedBy")
                          ) +
                          " "
                      )
                    ])
                  ]
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "col-md-12 d-flex align-items-end justify-content-end" },
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "ripple",
                rawName: "v-ripple.400",
                value: "rgba(255, 255, 255, 0.15)",
                expression: "'rgba(255, 255, 255, 0.15)'",
                modifiers: { "400": true }
              }
            ],
            attrs: { "data-cy": "add-document-button", variant: "primary" },
            on: {
              click: function($event) {
                return _vm.addDocument()
              }
            }
          },
          [_vm._v(" Agregar Documento ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }